<!-- Main Page Start -->
<section class="main-wrapper chatContainer">
    <div class="container">
        <div class="row">
            <div class="col-sm-4 col-lg-4 col-md-4 bg-white">
                <div class="flexClass padding-sm">
                    <h6 class="heading-6 m-0">All messages</h6>
                    <div class="dropdown leftBox" ngbDropdown>
                        <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                            <img src="assets/images/filter.svg" alt="filter"></a>
                        <ul class="dropdown-menu dropdown-menu-right" ngbDropdownMenu
                            aria-labelledby="dropdown_profile_area">
                            <li [ngClass]="{'activeFilter' : chatListFilterBy == 'all'}">
                                <a (click)="onFilterChatList('all')" class="dropdown-item"
                                    href="javascript:void(0);">All
                                    Chats</a>
                            </li>
                            <li [ngClass]="{'activeFilter' : chatListFilterBy == 'unread'}">
                                <a (click)="onFilterChatList('unread')" class="dropdown-item"
                                    href="javascript:void(0);">Unread
                                    Chats</a>
                            </li>
                        </ul>
                    </div>
                    <div class="input_msg_write" hidden>
                        <input type="text" class="write_msg" [(ngModel)]="chatListSearchBy"
                            placeholder="Search By Company and Job Title">
                    </div>
                </div>
                <!-- Messages -->
                <div class="leftSideUser">
                    <ng-container
                        *ngIf="(userChats | chatFilter: chatListSearchBy : chatListFilterBy : userId) as chatResult">
                        <ul class="friend-list">
                           
                            <li [ngClass]="{'active':selectedUserChat?.chat_dialog_id == userChat.chat_dialog_id}"
                                class=" bounceInDown" *ngFor="let userChat of chatResult; let i = index;">
                                <a href="javascript:void(0);" class="clearfix" (click)="openChatBox(userChat?.job_id)"
                                    *ngIf="userChat?.job_id">
                                    <img [src]="userChat.job_pic == ''? '../../../assets/images/profile-img.jpg':globalUrl+userChat.job_pic"
                                        alt="{{userChat?.job_name}}" class="img-circle">
                                    <div class="friend-name">
                                        <strong>{{userChat?.company_name || '-'}} </strong>
                                        <p>{{userChat?.company_name || '-'}}</p>
                                    </div>
                                    <div class="highlite"><span class="firstlCaptial">{{userChat.job_name}}</span></div>
                                    <div *ngIf="userChat?.last_message_time > userChat?.clear_chat_time[userId]"
                                        class="last-message text-muted"><span
                                        >{{userChat?.last_message[userId]}}</span></div>
                                    <small class="time text-muted" *ngIf="userChat?.last_message_time">{{userChat?.last_message_time ?(userChat?.last_message_time | dateAgoConvertor):''}}</small>
                                    <small *ngIf="userChat.unread_count[userId] > 0"
                                        class="chat-alert label label-danger">{{userChat?.unread_count[userId]}}</small>
                                </a>
                            </li>
                        </ul>
                        <div class="noDataFound" *ngIf="userChats.length == 0">
                            <h2>No Chats Available</h2>
                        </div>
                    </ng-container>
                </div>
                <!-- End -->
            </div>

            <!--  -->
            <div class="col-sm-8 col-lg-8 col-md-8" *ngIf="selectedUserChat">
                <div class="bgwhite">
                    <div class="action-header">
                        <div class="chattop">
                            <img [src]="selectedUserChat.job_pic  == '' ? '../../../assets/images/profile-img.jpg':globalUrl + selectedUserChat.job_pic"
                                alt="BEE" class="img-circle">
                            <div class="friend-name">
                                <strong>{{selectedUserChat.job_name}}</strong>
                                <p>{{selectedUserChat.company_name || '-'}}</p>
                            </div>
                        </div>
                        <li class="dropdown open innelist1" ngbDropdown>
                            <a data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"
                                id="dropdown_profile_area" ngbDropdownToggle>
                                <img src="assets/images/ic_option.svg"></a>
                            <ul class="dropdown-menu dropdown-menu-right" ngbDropdownMenu
                                aria-labelledby="dropdown_profile_area">
                                <li>
                                    <a (click)="clearUserChat()" class="dropdown-item" href="javascript:void(0);">Clear
                                        Chat</a>
                                </li>
                                <li>
                                    <a (click)="blockUnblockUser()" class="dropdown-item"
                                        href="javascript:void(0);">{{selectedUserChat?.block_status[userId] == 1?
                                        'Unblock': 'Block'}}</a>
                                </li>
                                <li>
                                    <a (click)="deleteUser()" class="dropdown-item" href="javascript:void(0);">Delete
                                        Chat</a>
                                </li>
                            </ul>
                        </li>
                    </div>
                    <div class="mesgs">
                        <div #messagesListContainer class="msg_history">
                            <div #messagesList *ngFor="let message of messagesList; let i= index">
                                <!-- <a class="day">{{msg.day}}</a> -->
                                <div
                                    *ngIf="((chatDialog.clear_chat_time && chatDialog.clear_chat_time[chatDialog.user_id]) < (message?.message_time) && (chatDialog.chat_dialog_id===message?.chat_dialog_id))">
                                    <a class="day" >{{ i > 0 ? ((getTime(i) | messageGroupby) ===  (message?.message_time | messageGroupby)? '': message?.message_time | messageGroupby ): message?.message_time | messageGroupby }} </a>
                                </div>

                                <div>
                                    <!-- <div> -->
                                    <div [ngClass]="message.sender_id == userId ? 'outgoing_msg':'received_msg'"
                                        *ngIf="((selectedUserChat.clear_chat_time && selectedUserChat.clear_chat_time[selectedUserChat.user_id]) < (message?.message_time) && (selectedUserChat.chat_dialog_id === message?.chat_dialog_id))">
                                        <span class="deleteIcon"
                                            (click)="deleteSingleMsg(message?.chat_dialog_id, message?.message_id, message.receiver_id)"><img
                                                src="../../../assets/images/delete.png" alt="delete icon"></span>
                                        <div
                                            [ngClass]="message.sender_id == userId ? message?.message_type == 1 ? 'sent_msg_text': message?.message_type == 2 ? 'sent_msg_image': 'sent_msg_pdf': message?.message_type == 1 ? 'received_msg_text': message?.message_type == 2 ? 'received_msg_image': 'received_msg_pdf'">
                                            <span class="time_date">{{message.message_time | date:'hh:mm a'}}</span>
                                            <p><span> {{message.message}}</span></p>
                                            <img class="iconPdf"
                                                *ngIf="message.attachment_url.length > 0 && message.message_type == 2"
                                                [src]="globalUrlChatDirectory+message.attachment_url"
                                                (click)="openImagePreview(message.attachment_url)">
                                            <a download="" target="_blank"
                                                href="https://media.honorvets.com/chatdocuments/{{message?.attachment_url}}"
                                                *ngIf="message.attachment_url.length > 0 && message.message_type == 3">
                                                <img src="{{ (message?.attachment_url).substr((message?.attachment_url).lastIndexOf('.') + 1).toLowerCase() =='pdf' ? '../../../../assets/images/pdf.png' : '../../../../assets/images/google-docs.png' }}"
                                                    class="iconPdf">
                                            </a>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                        </div>
                        <!-- end -->
                        <!-- *ngIf="selectedUserChat.block_status[userId] == 0 && selectedUserChat.block_status[selectedUserChat.job_id] == 0" -->
                        <div class="msgbottom">
                            <label for="myfile">
                                <a><input type="file" id="myfile" name="myfile" class="upload-pic"
                                        accept=".png, .jpg, .jpeg, .pdf, .docx, .doc" (change)="upload($event)"><img
                                        src="assets/images/ic_attach.svg"></a>
                            </label>
                            <div class="type_msg">
                                <div class="input_msg_write">
                                    <div *ngIf="choosedFileBase64" class="fileAttched">
                                        <div class="file-preview-container">
                                            <ng-container
                                                *ngIf="extension() == 'jpeg' || extension() == 'jpg' || extension() == 'png'; then image; else pdf">
                                            </ng-container>
                                            <div (click)="resetSelectedFile()" class="image-cross"><span>X</span></div>
                                        </div>
                                    </div>
                                    <textarea class="form-control write_msg" [(ngModel)]="messageText"
                                        placeholder="{{ choosedFileBase64 ? '': 'Type a message'}}"
                                        [readonly]="choosedFileBase64" *ngIf="!choosedFileBase64"></textarea>
                                    <!--  *ngIf="messageText.length > 0 || choosedFileBase64" -->
                                    <button class="msg_send_btn" type="button"
                                        (click)="choosedFileBase64 ?  sendFile() : sendMessage()">
                                        <img src="assets/images/ic_send.svg">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<ng-template #image>
    <img src="{{choosedFileBase64}}" width="100px" height="100px">
</ng-template>
<ng-template #pdf>
    <img src="../../../../assets/images/pdf.png" *ngIf="extension() == 'pdf'; else docs" width="100px" height="100px">
</ng-template>
<ng-template #docs>
    <img src="../../../../assets/images/google-docs.png" width="100px" height="100px">
</ng-template>